import firebase from "firebase/app";
import { readable } from "svelte/store";
export const userStore = readable(undefined, (set) => {
    const unsub = firebase.auth().onAuthStateChanged((value) => {
        set(value);
    });
    return unsub;
});
export const redirectToAuthorizationFlow = () => {
    const url = `https://app.youneedabudget.com/oauth/authorize?client_id=${YNAB_OAUTH_CLIENT_ID}&redirect_uri=${YNAB_OAUTH_RETURN_URL}&response_type=code`;
    document.location.href = url;
};
export const retrieveAuthorizationCodeFromQueryString = () => {
    const url = new URL(document.location.href);
    if (url.searchParams.has("code")) {
        const code = url.searchParams.get("code");
        url.searchParams.delete("code");
        history.replaceState("removed code", "", "?" + url.searchParams.toString());
        return code;
    }
};
export const createJWTWithCode = async (code) => {
    const result = await firebase.functions().httpsCallable("register")({ code });
    return result.data;
};
export const loginWithJWTToken = (token) => {
    return firebase
        .auth()
        .signInWithCustomToken(token)
        .catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === "auth/invalid-custom-token") {
            alert("The token you provided is not valid.");
        }
        else {
            console.error(error);
        }
        return false;
    });
};
export const logout = () => firebase.auth().signOut();
